import { render, staticRenderFns } from "./PrivadoLiquidarModal.vue?vue&type=template&id=620495f0"
import script from "./PrivadoLiquidarModal.vue?vue&type=script&lang=js"
export * from "./PrivadoLiquidarModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports